<template>
    <div class="g_restrict">
        <div
            class="g_table"
            v-if="!data.tableModularSolutions.hide">
            <div class="g_header">
                <Heading
                    :level="3"
                    v-html="data.tableModularSolutions.title" />
            </div>
            <table>
                <div
                    :key="item.id"
                    aria-hidden="true"
                    v-for="item in data.tableModularSolutions.list">
                    <tr>
                        <th>
                            <Paragraph
                                :content="item.header"
                                size="L" />
                        </th>
                    </tr>
                    <tr>
                        <td
                            :key="item.id"
                            v-for="item in item.answers">
                            <p
                                class="g_visually_hidden"
                                v-html="$json.config.yes"
                                v-if="item.answer" />
                            <p
                                class="g_visually_hidden"
                                v-else
                                v-html="$json.config.no" />
                            <img
                                aria-hidden="true"
                                class="g_img"
                                v-img-src="{ folder: 'icons', name: item.answer, ext: 'svg', suffix: false}" :alt="item.answer ? $json.config.yes : $json.config.no">
                        </td>
                    </tr>
                    <tr v-if="item.disclaimer">
                        <div class="g_disclaimer">
                            <Paragraph
                                :content="item.disclaimer"
                                size="XS" />
                        </div>
                    </tr>
                </div>
            </table>
        </div>
        <div
            class="g_table"
            v-if="!data.tableSimpleSolutions.hide">
            <div class="g_header">
                <Heading
                    :level="3"
                    v-html="data.tableSimpleSolutions.title" />
            </div>
            <table>
                <div
                    :key="item.id"
                    aria-hidden="true"
                    v-for="item in data.tableSimpleSolutions.list">
                    <tr>
                        <th>
                            <Paragraph
                                :content="item.header"
                                size="L" />
                        </th>
                    </tr>
                    <tr>
                        <td
                            :key="item.id"
                            v-for="item in item.answers">
                            <p
                                class="g_visually_hidden"
                                v-html="$json.config.yes"
                                v-if="item.answer" />
                            <p
                                class="g_visually_hidden"
                                v-else
                                v-html="$json.config.no" />
                            <img
                                aria-hidden="true"
                                class="g_img"
                                v-img-src="{ folder: 'icons', name: item.answer, ext: 'svg', suffix: false}" :alt="item.answer ? $json.config.yes : $json.config.no">
                        </td>
                    </tr>
                    <tr v-if="item.disclaimer">
                        <div class="g_disclaimer">
                            <Paragraph
                                :content="item.disclaimer"
                                size="XS" />
                        </div>
                    </tr>
                </div>
            </table>
        </div>
        <div
            class="g_table"
            v-if="!data.tablePaymentSolutions.hide">
            <div class="g_header">
                <Heading
                    :level="3"
                    v-html="data.tablePaymentSolutions.title" />
            </div>
            <table class="g_payment_solutions">
                <div
                    :index="index"
                    :key="item.id"
                    aria-hidden="true"
                    v-for="(item,index) in data.tablePaymentSolutions.list">
                    <tr>
                        <th class="g_button">
                            <Paragraph
                                :content="item.header"
                                size="L" />
                        </th>
                    </tr>
                    <tr>
                        <td
                            :key="item.id"
                            v-for="item in item.answers">
                            <p
                                class="g_visually_hidden"
                                v-html="$json.config.yes"
                                v-if="item.answer" />
                            <p
                                class="g_visually_hidden"
                                v-else
                                v-html="$json.config.no" />
                            <img
                                aria-hidden="true"
                                class="g_img"
                                v-img-src="{ folder: 'icons', name: item.answer, ext: 'svg', suffix: false}" :alt="item.answer ? $json.config.yes : $json.config.no">
                        </td>
                    </tr>
                    <tr v-if="item.disclaimer">
                        <div class="g_disclaimer">
                            <Paragraph
                                :content="item.disclaimer"
                                size="XS" />
                        </div>
                    </tr>
                </div>
            </table>
        </div>
        <div
            class="g_table"
            v-if="!data.tableServices.hide">
            <div class="g_header">
                <Heading
                    :level="3"
                    v-html="data.tableServices.title" />
            </div>
            <table>
                <div
                    :key="item.id"
                    aria-hidden="true"
                    v-for="item in data.tableServices.list">
                    <tr>
                        <th>
                            <Paragraph
                                :content="item.header"
                                size="L" />
                        </th>
                    </tr>
                    <tr>
                        <td
                            :key="item.id"
                            v-for="item in item.answers">
                            <p
                                class="g_visually_hidden"
                                v-html="$json.config.yes"
                                v-if="item.answer" />
                            <p
                                class="g_visually_hidden"
                                v-else
                                v-html="$json.config.no" />
                            <img
                                aria-hidden="true"
                                class="g_img"
                                v-img-src="{ folder: 'icons', name: item.answer, ext: 'svg', suffix: false}" :alt="item.answer ? $json.config.yes : $json.config.no">
                        </td>
                    </tr>
                    <tr v-if="item.disclaimer">
                        <div class="g_disclaimer">
                            <Paragraph
                                :content="item.disclaimer"
                                size="XS" />
                        </div>
                    </tr>
                </div>
            </table>
        </div>
        <div
            class="g_table"
            v-if="!data.tableDimensions.hide">
            <div class="g_header">
                <Heading
                    :level="3"
                    v-html="data.tableDimensions.title" />
            </div>
            <table>
                <div
                    :key="item.id"
                    aria-hidden="true"
                    v-for="(item) in data.tableDimensions.list">
                    <tr>
                        <th>
                            <Paragraph
                                :content="item.header"
                                size="L" />
                        </th>
                    </tr>
                    <tr>
                        <td
                            :key="item.id"
                            class="g_dimensions g_txt_L"
                            v-for="item in item.answers"
                            v-html="item.answer"></td>
                    </tr>
                    <tr v-if="item.disclaimer">
                        <div class="g_disclaimer">
                            <Paragraph
                                :content="item.disclaimer"
                                size="XS" />
                        </div>
                    </tr>
                </div>
            </table>
        </div>
    </div>
</template>

<script>
// Core components
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Tracking from 'nespresso-library/src/core/tracking'

export default {
    name: 'TabContent',
    props: ['data'],
    components: {
        Heading,
        Paragraph
    },
    data () {
        return {
            popinOpened: false,
            popinReportsOpened: false,
            index: null
        }
    },
    methods: {
        openCollection (index, item) {
            this.$refs.popin.index = index
        },
        swiperOption () {
            let firstInit = false
            const defaultSwiperOption = {
                // nextTick is a component's own property, and if nextTick is set to true, the component will not instantiate the swiper through nextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
                nextTick: true,
                slideToClickedSlide: this.$breakpoint.isS,
                slidesPerView: this.$breakpoint.isS ? 1 : 1,
                initialSlide: 4,
                runCallbacksOnInit: true,
                virtualTranslate: this.$touch,
                prevButton: `.swiper-button-prev`,
                nextButton: `.swiper-button-next`,
                // slideToClickedSlide: true,

                onSlideChangeEnd: (swiper) => {
                    if (!firstInit) {
                        swiper.slideTo(this.$refs.popin.index, 0, false)
                        firstInit = true
                    }
                    Tracking.customEvent({
                        category: 'User Engagement',
                        action: 'Click',
                        label: `${this.$trackingLandingLabel}  - Slider in popin`,
                        interaction: 0
                    })
                }
            }
            return defaultSwiperOption
        },
        track (cta) {
            Tracking.customEvent({
                category: 'User Engagement',
                action: 'Click',
                label: `${this.$trackingLandingLabel}  - Click on table's ${cta}`,
                interaction: 0
            })
        }
    }
}
</script>
